export enum STATUS_INDICATOR {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
    DEFAULT = 'default',
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
}
